export const BOT_WIDGET_COPY = {
  catering: {
    eyebrow: 'Catering Assistant',
    greeting:
      "Hi! I'm Bottle Bot 👋 Ask me anything about your catering store — your delivery days, order cutoffs, what's on your menu, and more.",
    placeholder: 'Ask about your catering store…',
    historyEmpty: 'No chats yet. Start a new conversation to ask about your catering store.'
  },
  ecommerce: {
    eyebrow: 'Store Assistant',
    greeting:
      "Hi! I'm Bottle Bot 👋 Ask me anything about your online store — your products, inventory, orders, discounts, shipping, and store settings.",
    placeholder: 'Ask about your online store…',
    historyEmpty: 'No chats yet. Start a new conversation to ask about your online store.'
  }
}

export function botWidgetCopy(platform) {
  return BOT_WIDGET_COPY[platform] || BOT_WIDGET_COPY.catering
}

export function botPlatformFromNamespace(namespace) {
  return namespace === 'ecommerceBot' ? 'ecommerce' : 'catering'
}
